// extracted by mini-css-extract-plugin
export var menuItem = "F_v9 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "F_wb d_Z d_bz d_bP";
export var menuMainLink = "F_wc d_f0 d_dB";
export var menuLink = "F_wd d_f0 d_dB";
export var icon = "F_p9 d_bC d_bP";
export var divider = "F_wf d_bC d_bP";
export var sublinks = "F_wg";
export var link = "F_mZ";
export var Link = "F_sJ s_sJ s_r2 s_sm";